module.exports = __webpack_public_path__ + "static/media/f_nose_hawk.d33befa3.png";